import type {TextInputWidgetConfig} from '../../types'
import React from 'react'
import {TextInput} from '../../../components/Input/TextInput'
import {Typography} from '@yandex-delivery/blocks'
import {useController, useFormContext} from 'react-hook-form'
import * as classes from './TextInput.classes'

export const TextInputWidget = ({
  height,
  placeholder,
  form_state_key,
}: Omit<TextInputWidgetConfig, 'type'> & {}): React.ReactElement => {
  const {control} = useFormContext()
  const {
    fieldState: {error, invalid},
  } = useController({control, name: form_state_key})
  return (
    <>
      <TextInput height={height} name={form_state_key} placeholder={placeholder} />
      {invalid && (
        <Typography className={classes.errorMessage} color="error" variant="caption2">
          {error?.message}
        </Typography>
      )}
    </>
  )
}
